// src/apiConfig.js

const getBackendUrl = () => {
  const protocol = window.location.protocol;
  return `${protocol}//api.archiveme.ai`;
};

export const API_URL = getBackendUrl();

